import PersonalizedSearchEnquiry from "./PersonalizedSearchEnquiry";

/**
 * Homepage personalized search — lead capture (criteria location + contact).
 * Kept as a thin wrapper for existing imports and test IDs.
 */
const SearchEntry = () => (
  <PersonalizedSearchEnquiry
    searchType="recherche"
    sourcePage="/"
    testIdPrefix="search-entry"
  />
);

export default SearchEntry;
